var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    fill: "none",
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 42.6667H43.3333V16H0V42.6667ZM9.85309 40.4427C9.16162 36.5634 6.10175 33.504 2.22222 32.8133V25.8534C6.1003 25.1629 9.15934 22.1055 9.85232 18.2283L33.4844 18.2472C34.1839 22.1152 37.239 25.1637 41.1104 25.8533L41.1107 32.8133C37.2314 33.5042 34.1717 36.5635 33.4802 40.4427H9.85309Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.111 36.0001C24.7929 36.0001 27.7777 33.0154 27.7777 29.3334C27.7777 25.6515 24.7929 22.6667 21.111 22.6667C17.4291 22.6667 14.4443 25.6515 14.4443 29.3334C14.4479 33.0138 17.4306 35.9965 21.111 36.0001Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.4445 31.0001C10.3649 31.0001 11.1112 30.2538 11.1112 29.3334C11.1112 28.413 10.3649 27.6667 9.4445 27.6667C8.52408 27.6667 7.77783 28.413 7.77783 29.3334C7.77783 30.254 8.52408 31.0001 9.4445 31.0001Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.8888 31.0001C34.8093 31.0001 35.5555 30.2538 35.5555 29.3334C35.5555 28.413 34.8093 27.6667 33.8888 27.6667C32.9684 27.6667 32.2222 28.413 32.2222 29.3334C32.2222 30.254 32.9684 31.0001 33.8888 31.0001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 7H51V37H45.416V14H8V7Z",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.915b4a17cc4c965efc64d31725179899.svg";
export { ForwardRef as ReactComponent };